import React, {Component} from 'react';
import CONFIG from '../../constants/parameters';

class Footer extends Component {

  render() {
    var date = new Date();
    return (
      <footer className="app-footer">
          <span className="redlink">  &copy; {date.getFullYear()} <a href={CONFIG.costumer.url}>  {`Visiter le site ${CONFIG.costumer.name}`}.</a> </span>
        {/*<span className="ml-auto italicText">Made by <a href={CONFIG.author.url}> <img src={'img/logo-whatson.png'} alt=""  style={{ width : 17}}/></a></span>*/}

      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js